import { SvgDataCatalogLineageDashboard, SvgDataCatalogLineageDashboardActive, SvgDataCatalogLineageDashboardWhite, SvgDataCatalogLineageDs, SvgDataCatalogLineageDsActive, SvgDataCatalogLineageDsWhite, SvgDataCatalogLineageFlow, SvgDataCatalogLineageFlowActive, SvgDataCatalogLineageFlowWhite, SvgDataCatalogLineageLens, SvgDataCatalogLineageLensActive, SvgDataCatalogLineageLensWhite, SvgDataCatalogLineageMetric, SvgDataCatalogLineageMetricActive, SvgDataCatalogLineageMetricWhite, SvgDataCatalogLineageServer, SvgDataCatalogLineageServerActive, SvgDataCatalogLineageServerWhite, SvgDataCatalogLineageSheet, SvgDataCatalogLineageSheetActive, SvgDataCatalogLineageSheetWhite, SvgDataCatalogLineageTable, SvgDataCatalogLineageTableActive, SvgDataCatalogLineageTableWhite, SvgDataCatalogLineageUsers, SvgDataCatalogLineageUsersActive, SvgDataCatalogLineageUsersWhite, SvgDataCatalogLineageVirtualConnection, SvgDataCatalogLineageVirtualConnectionActive, SvgDataCatalogLineageVirtualConnectionTable, SvgDataCatalogLineageVirtualConnectionTableActive, SvgDataCatalogLineageVirtualConnectionTableWhite, SvgDataCatalogLineageVirtualConnectionWhite, SvgDataCatalogLineageWorkbook, SvgDataCatalogLineageWorkbookActive, SvgDataCatalogLineageWorkbookWhite, SvgSchemaViewerBlank } from '../../../../../gen-src/icons';

export enum LineageItemType {
  Dashboard = 'dashboard',
  Database = 'database',
  Datasource = 'datasource',
  Flow = 'flow',
  Lens = 'lens',
  Metric = 'metric',
  Sheet = 'sheet',
  Table = 'table',
  User = 'user',
  VirtualConnection = 'virtualConnection',
  VirtualConnectionTable = 'virtualConnectionTable',
  Workbook = 'workbook',
}

export enum IconType {
  inactive = 'inactive',
  active = 'active',
  white = 'white'
}

type SvgIcon = React.ElementType<React.SVGProps<SVGSVGElement>>;

const activeIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboardActive,
  database: SvgDataCatalogLineageServerActive,
  datasource: SvgDataCatalogLineageDsActive,
  flow: SvgDataCatalogLineageFlowActive,
  lens: SvgDataCatalogLineageLensActive,
  metric: SvgDataCatalogLineageMetricActive,
  sheet: SvgDataCatalogLineageSheetActive,
  table: SvgDataCatalogLineageTableActive,
  user: SvgDataCatalogLineageUsersActive,
  virtualConnection: SvgDataCatalogLineageVirtualConnectionActive,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTableActive,
  workbook: SvgDataCatalogLineageWorkbookActive,
};

const inactiveIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboard,
  database: SvgDataCatalogLineageServer,
  datasource: SvgDataCatalogLineageDs,
  flow: SvgDataCatalogLineageFlow,
  lens: SvgDataCatalogLineageLens,
  metric: SvgDataCatalogLineageMetric,
  sheet: SvgDataCatalogLineageSheet,
  table: SvgDataCatalogLineageTable,
  user: SvgDataCatalogLineageUsers,
  virtualConnection: SvgDataCatalogLineageVirtualConnection,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTable,
  workbook: SvgDataCatalogLineageWorkbook,
};

const whiteIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboardWhite,
  database: SvgDataCatalogLineageServerWhite,
  datasource: SvgDataCatalogLineageDsWhite,
  flow: SvgDataCatalogLineageFlowWhite,
  lens: SvgDataCatalogLineageLensWhite,
  metric: SvgDataCatalogLineageMetricWhite,
  sheet: SvgDataCatalogLineageSheetWhite,
  table: SvgDataCatalogLineageTableWhite,
  user: SvgDataCatalogLineageUsersWhite,
  virtualConnection: SvgDataCatalogLineageVirtualConnectionWhite,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTableWhite,
  workbook: SvgDataCatalogLineageWorkbookWhite,
};

export function getIconForContentType(contentType: LineageItemType, iconType?: IconType): SvgIcon {
  const iconDirectory =
    iconType === IconType.active ? activeIcons :
      iconType === IconType.white ? whiteIcons :
        inactiveIcons;
  return iconDirectory[contentType] || SvgSchemaViewerBlank;
}
